/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/SplitCamelCaseString.ts
 * @create:      2025-07-01 18:00:22.196
 * @modify:      2025-07-11 21:19:12.952
 * @version:     6.0.0
 * @times:       4
 * @lines:       58
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ReplaceAll } from "../string/ReplaceAll";

/**
 * Splits a camelCase string into words separated by a single space.
 * 
 * This function takes a camelCase string and inserts a space before each uppercase letter sequence
 * and each uppercase letter followed by a lowercase letter. It then cleans up any double spaces
 * and removes leading whitespace.
 * 
 * @param camelCaseStr - The camelCase string to be split.
 * @returns A new string with words separated by a single space.
 * 
 * @since 1.1.1
 * @version 2023-11-25
 */
export function SplitCamelCaseString(camelCaseStr: string) {
    // return camelCaseStr.replace(/([a-z])([A-Z])/g, ' $1 $2');
    let result = camelCaseStr
        .replace(/([A-Z]+)/g, " $1")
        .replace(/([A-Z][a-z])/g, " $1");

    result = ReplaceAll(result, "  ", " ").trimStart();

    return result;
}
